
import Vue from 'vue';
import CircleLoading from '~/components/util/CircleLoading.vue';
import {waitTimeout} from '~/lib/util/util';


export default Vue.extend({
  components: {CircleLoading},
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    instaCircle: {
      type: Boolean,
      required: false,
      default: false
    },
    blur: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      show: false
    };
  },
  async mounted() {
    if(this.loading) {
      await waitTimeout(10);
      this.show = true;
    }
  },
  watch: {
    async loading(l: boolean) {
      if(l) {
        await waitTimeout(10);
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
})
